export default [
  {
    path: '/app/blog',
    name: 'Blog',
    component: () => import('@/views/Admin/Blog/Index.vue'),
    meta: {
      pageTitle: 'Blog',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_BLOG',
      action: 'read',
    },
  },
  {
    path: '/app/blog/add',
    name: 'BlogAdd',
    component: () => import('@/views/Admin/Blog/Add.vue'),
    meta: {
      pageTitle: 'Blog',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/blog',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_BLOG',
      action: 'read',
    },
  },
  {
    path: '/app/blog/edit/:id',
    name: 'BlogEdit',
    component: () => import('@/views/Admin/Blog/Edit.vue'),
    meta: {
      pageTitle: 'Blog',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/blog',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_BLOG',
      action: 'read',
    },
  },
]
